import categoryFr from '~/src/common/components/Category/category.fr';
import completeOrderBanner from '~/src/common/components/CompleteOrderBanner/complete-order-banner.fr';
import deliveryProgressBar from '~/src/common/components/DeliveryProgressBar/delivery-progress-bar.fr';
import deliverySlots from '~/src/common/components/DeliverySlots/delivery-slots.fr';
import errorBoundary from '~/src/common/components/ErrorBoundary/error-boundary.fr';
import validation from '~/src/common/components/Form/validation.fr';
import googleAutocomplete from '~/src/common/components/GoogleAutocompleteInput/google-autocomplete.fr';
import productCard from '~/src/common/components/GridCard/ProductCard/product-card.fr';
import accountScreen from '~/src/common/components/Layout/account-screen.fr';
import legalInfo from '~/src/common/components/LegalInfo/legal-info.fr';
import loyalty from '~/src/common/components/Loyalty/loyalty.fr';
import passwordRules from '~/src/common/components/PasswordRules/password-rules.fr';
import productListItem from '~/src/common/components/ProductListItem/product-list-item.fr';
import productsGrid from '~/src/common/components/ProductsGrid/products-grid.fr';
import prospectEmailForm from '~/src/common/components/ProspectEmailForm/prospect-email-form.fr';
import readmore from '~/src/common/components/ReadMore/read-more.fr';
import shareReferralCodeButton from '~/src/common/components/Referral/ShareReferralCodeButton/share-referral-code-button.fr';
import search from '~/src/common/components/Search/search.fr';
import serverError from '~/src/common/components/ServerError/server-error.fr';
import signinContent from '~/src/common/components/SigninContent/signin-content.fr';
import smallHeader from '~/src/common/components/SmallHeader/small-header.fr';
import relatedArticles from '~/src/common/hooks/relatedArticles/related-articles.fr';
import builder from '~/src/common/services/Builder/builder.fr';
import errors from '~/src/common/services/error-handler/errors.fr';
import toaster from '~/src/common/services/Toaster/toaster.fr';
import price from '~/src/common/utils/price.fr';
import benefitsScreen from '~/src/screens/Account/Benefits/benefits-screen.fr';
import myAccountScreen from '~/src/screens/Account/my-account-screen.fr';
import orderAgainProductsModal from '~/src/screens/Account/Orders/OrderAgainProductsModal/order-again-products-modal.fr';
import orderScreen from '~/src/screens/Account/Orders/OrderScreen/order-screen.fr';
import accountOrdersScreen from '~/src/screens/Account/Orders/OrdersScreen/account-orders-screen.fr';
import selectSlotModal from '~/src/screens/Account/Orders/SelectSlotModal/select-slot-modal.fr';
import addressesScreen from '~/src/screens/Account/Settings/Addresses/AddressesScreen/addresses-screen.fr';
import editAddressScreen from '~/src/screens/Account/Settings/Addresses/EditAddressScreen/edit-address-screen.fr';
import selectAddressModal from '~/src/screens/Account/Settings/Addresses/EditAddressScreen/SelectAddressModal/select-address-modal.fr';
import communicationsScreen from '~/src/screens/Account/Settings/CommunicationsScreen/communications-screen.fr';
import paymentScreen from '~/src/screens/Account/Settings/PaymentScreen/payment-screen.fr';
import personalInformationScreen from '~/src/screens/Account/Settings/PersonalInformationScreen/personal-information-screen.fr';
import resetPasswordScreen from '~/src/screens/Account/Settings/ResetPasswordScreen/reset-password-screen.fr';
import settingsScreen from '~/src/screens/Account/Settings/settings-screen.fr';
import accountManagementModal from '~/src/screens/AccountManagementModal/account-management-modal.fr';
import footer from '~/src/screens/App/Footer/footer.fr';
import navigation from '~/src/screens/App/Header/Navigation/navigation.fr';
import cartScreen from '~/src/screens/CartScreen/cart-screen.fr';
import lastMinutePurchasePanel from '~/src/screens/CartScreen/LastMinutePurchasePanel/last-minute-purchase-panel.fr';
import updatedProductsPanel from '~/src/screens/CartScreen/UpdatedProductsPanel/updated-products-panel.fr';
import productScreen from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/product-screen.fr';
import recipeScreen from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/recipe-screen.fr';
import checkoutScreen from '~/src/screens/Checkout/checkout-screen.fr';
import CheckoutConfirmationOrderModal from '~/src/screens/Checkout/CheckoutConfirmationOrderModal/checkout-confirmation-order-modal.fr';
import deliveryInfo from '~/src/screens/Checkout/DeliveryInfo/delivery-info.fr';
import paymentTypes from '~/src/screens/Checkout/PaymentTypesList/payment-types.fr';
import ReplaceMissingProductsModal from '~/src/screens/Checkout/ReplaceMissingProductsSection/ReplaceMissingProductsModal/replace-missing-products-modal.fr';
import couponConfirmationModal from '~/src/screens/CouponConfirmationModal/coupon-confirmation-modal.fr';
import deliveryAddressModal from '~/src/screens/Delivery/DeliveryAddressModal/delivery-address-modal.fr';
import deliveryManualAddressModal from '~/src/screens/Delivery/DeliveryManualAddressModal/delivery-manual-address-modal.fr';
import pickupAddressModal from '~/src/screens/Delivery/PickupAddressModal/pickup-address-modal.fr';
import deliverySelectSlotModal from '~/src/screens/Delivery/SelectSlotModal/select-slot-modal.fr';
import deliveryTrackingDrawer from '~/src/screens/DeliveryTrackingDrawer/delivery-tracking-drawer.fr';
import expiredCompleteOrderModal from '~/src/screens/ExpiredCompleteOrderModal/expired-complete-order.fr';
import expiredDeliverySlotModal from '~/src/screens/ExpiredDeliverySlotModal/expired-delivery-slot.fr';
import googleDocScreen from '~/src/screens/GoogleDocScreen/google-doc-screen.fr';
import groceryListBanner from '~/src/screens/GroceryList/GroceryListBanner/grocery-list-banner.fr';
import groceryListModal from '~/src/screens/GroceryList/GroceryListModal/grocery-list-modal.fr';
import groceryListScreen from '~/src/screens/GroceryList/GroceryListScreen/grocery-list-screen.fr';
import home from '~/src/screens/Home/home.fr';
import inProgressOrdersBanner from '~/src/screens/Home/InProgressOrdersBanner/in-progress-orders-banner.fr';
import myProductsScreen from '~/src/screens/MyProducts/my-products.fr';
import outdatedBrowser from '~/src/screens/OutdatedBrowser/outdated-browser.fr';
import recipeHomeScreen from '~/src/screens/Recipe/RecipeHomeScreen/recipe-home.fr';
import recipesByCategoryScreen from '~/src/screens/Recipe/RecipesByCategoryScreen/recipes-by-category.fr';
import recipesByTypeScreen from '~/src/screens/Recipe/RecipesByTypeScreen/recipes-by-type.fr';
import referralModal from '~/src/screens/ReferralModal/referral-modal.fr';
import resetPasswordModal from '~/src/screens/ResetPasswordModal/reset-password-modal.fr';
import searchProductsScreen from '~/src/screens/SearchProductsScreen/search-products-screen.fr';
import substituteProducts from '~/src/screens/SubstituteProducts/substitute-products.fr';
import weightExplanationModal from '~/src/screens/WeightPricingExplanationModal/weight-pricing-explanation-modal.fr';

import common from './fr/common';
import date from './fr/date';

const fr = {
  'server-error': serverError,
  'form': {
    validation,
  },
  builder,
  common,
  date,
  footer,
  home,
  'account-management-modal': accountManagementModal,
  'account-screen': accountScreen,
  'my-account': myAccountScreen,
  'account-orders-screen': accountOrdersScreen,
  'order-screen': orderScreen,
  'order-again-products-modal': orderAgainProductsModal,
  'benefits-screen': benefitsScreen,
  'settings-screen': settingsScreen,
  'addresses-screen': addressesScreen,
  'edit-address-screen': editAddressScreen,
  'select-address-modal': selectAddressModal,
  'personal-information-screen': personalInformationScreen,
  'reset-password-screen': resetPasswordScreen,
  'payment-screen': paymentScreen,
  'communications-screen': communicationsScreen,
  'category': categoryFr,
  'cart-screen': cartScreen,
  'checkout-confirmation-order-modal': CheckoutConfirmationOrderModal,
  'checkout-screen': checkoutScreen,
  'complete-order': completeOrderBanner,
  'coupon-confirmation-modal': couponConfirmationModal,
  'delivery-address-modal': deliveryAddressModal,
  'delivery-manual-address-modal': deliveryManualAddressModal,
  'delivery-info': deliveryInfo,
  'delivery-progress-bar': deliveryProgressBar,
  'delivery-tracking-drawer': deliveryTrackingDrawer,
  'error-boundary': errorBoundary,
  'errors': errors,
  'expired-delivery-slot-modal': expiredDeliverySlotModal,
  'expired-complete-order-modal': expiredCompleteOrderModal,
  'google-autocomplete': googleAutocomplete,
  'grocery-list-banner': groceryListBanner,
  'grocery-list-modal': groceryListModal,
  'grocery-list-screen': groceryListScreen,
  'in-progress-orders-banner': inProgressOrdersBanner,
  'last-minute-purchase-panel': lastMinutePurchasePanel,
  'loyalty': loyalty,
  'my-products-screen': myProductsScreen,
  'navigation': navigation,
  'outdated-browser': outdatedBrowser,
  'password-rules': passwordRules,
  'payment-types': paymentTypes,
  'pickup-address-modal': pickupAddressModal,
  'product-card': productCard,
  'product-list-item': productListItem,
  'products-grid': productsGrid,
  'prospect-email-form': prospectEmailForm,
  'read-more': readmore,
  'recipe-screen': recipeScreen,
  'referral-modal': referralModal,
  'related-articles': relatedArticles,
  'replace-missing-products-modal': ReplaceMissingProductsModal,
  'reset-password-modal': resetPasswordModal,
  'share-referral-code-button': shareReferralCodeButton,
  'search-products-screen': searchProductsScreen,
  'search': search,
  'delivery-select-slot-modal': deliverySelectSlotModal,
  'signin-content': signinContent,
  'small-header': smallHeader,
  'substitute-products-screen': substituteProducts,
  'toaster': toaster,
  'updated-products-panel': updatedProductsPanel,
  'view-product-screen': productScreen,
  'weight-explanation-modal': weightExplanationModal,
  price,
  'select-slot-modal': selectSlotModal,
  'delivery-slots': deliverySlots,
  'legal-info': legalInfo,
  'google-doc-screen': googleDocScreen,
  'recipe-home-screen': recipeHomeScreen,
  'recipes-by-type-screen': recipesByTypeScreen,
  'recipes-by-category-screen': recipesByCategoryScreen,
};

export default fr;
